import { schema } from './schema';
import { initialValues } from './initialValues';
import { Form } from 'vee-validate';
import FormBody from './components/FormBody.vue';
import { ref } from 'vue';


export default {
  __name: 'ReviewForm',
  setup(__props, { expose }) {
  expose();

const status = ref('idle');
const onSubmit = (data) => {
    const formData = new FormData();

    formData.append('action', 'add_review');
    formData.append('message', data.message);
    formData.append('rating', data.rating);
    formData.append('email', data.email);

    fetch(jsData.ajaxUrl, {
        method: 'POST',
        body: formData,
    })
        .then((response) => response.json())
        .then(() => {
            status.value = 'success';
        });
};

const siteUrl = jsData.themeUrl;

const __returned__ = { status, onSubmit, siteUrl, get schema() { return schema }, get initialValues() { return initialValues }, get Form() { return Form }, FormBody, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}